import styled from 'styled-components';
import theme from './../../../theme';

export const OverlayLoader = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;

    .loader-wrapper {
        text-align: center;
        position: fixed;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
    }

    .loader-text-wrapper {
        width: 500px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f4f4f4;
        box-shadow: #ccc 0 2px 15px -8px;
        border-radius: 3px;
        grid-gap: 10px;
        padding: 35px;
        border: 1px solid ${theme.colors.border.aaa};
    }

    .lds-ripple div {
        border-color: ${theme.colors.text.primary};
    }

    .loader-text {
        color: ${theme.colors.text.primary};
        font-size: 1rem;
        font-weight: 400;
        white-space: break-spaces;
    }
    .curtain {
        position: fixed;
        background: #000;
        z-index: 9998;
        opacity: 0.3;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
`;

export const ContainerOverlayLoader = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 999;

    .loader-wrapper {
        transform: scale(0.75);
        text-align: center;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.75);
    }

    .loader-text {
        color: #12427d;
        font-size: 1.25rem;
    }
`;

export const FeatureSpinnerWrapper = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.85);
    z-index: 999;
    align-items: center;

    .inner-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
    }
`;

export const GlobalOverlayLoader = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    display: flex;
    align-items: flex-start;
    padding-top: 35vh;
    justify-content: center;

    .loader-content {
        z-index: 10000;
        background: white;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 300px;
    }

    .curtain {
        position: fixed;
        background: #000;
        z-index: 9998;
        opacity: 0.4;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
`;
